<template>
    <div class="navigation-container position-sticky d-flex justify-content-center mx-auto"
         :class="{ 'section-navbar': model.chapter_id }">
        <div class="crypto-book-nav-wrapper d-flex justify-content-center fw-600 pb-2 mb-2">
            <SectionNavbar v-if="model.chapter_id"
                           :next-section="nextSection"
                           :prev-section="prevSection"
                           @mobileSidebarToggle="toggleMobileSidebar" />
            <GlossaryNavbar v-else
                            :next-section="nextSection"
                            :prev-section="prevSection"
                            @mobileSidebarToggle="toggleMobileSidebar" />
        </div>
        <MobileSidebar v-if="!isCustomDesktop && isMobileSidebarOpened"
                       :chapter-list="chapterList"
                       :current-chapter="currentChapter"
                       :current-section="currentSection"
                       @closeMobileSidebar="toggleMobileSidebar" />
    </div>
</template>

<script>
    import { ref } from 'vue';
    import SectionNavbar from './SectionNavbar.vue';
    import GlossaryNavbar from './GlossaryNavbar.vue';
    import MobileSidebar from './MobileSidebar.vue';
    import { useCustomDeviceSize } from '@/js/composables/useCustomDeviceSize';

    export default {
        name: 'CryptoBookNavigation',
        components: { GlossaryNavbar, SectionNavbar, MobileSidebar },
        props: {
            nextSection: {
                type: Object,
                default() {
                    return {};
                },
            },
            prevSection: {
                type: Object,
                default() {
                    return {};
                },
            },
            chapterList: {
                type: Array,
                default() {
                    return [];
                },
            },
            currentChapter: {
                type: String,
                default: '',
            },
            currentSection: {
                type: String,
                default: '',
            },
            model: {
                type: Object,
                default() {
                    return {};
                },
            },
        },
        setup() {
            const { isCustomDesktop } = useCustomDeviceSize();
            const isMobileSidebarOpened = ref(false);

            return {
                isCustomDesktop,
                isMobileSidebarOpened,
            };
        },
        methods: {
            toggleMobileSidebar() {
                this.isMobileSidebarOpened = !this.isMobileSidebarOpened;
            },
        },
    };
</script>

<style scoped lang="scss">
@use "@/sass/partials/breakpoints" as breakpoints;
@use "@/sass/partials/z-index" as ZIndex;

$navigation-container-width: 310px;
$md-navigation-container-width: 564px;

.navigation-container {
    z-index: ZIndex.$crypto-book-nav-wrapper-z-index;
    bottom: 0;
    width: $navigation-container-width;

    @media (min-width: breakpoints.$md-breakpoint) {
        width: $md-navigation-container-width;
    }
}

body.game-active {
    .navigation-container {
        display: none !important;
    }
}
</style>
